// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-block;
  max-width: 100%;
}

:host([size=full]) {
  width: 100%;
  height: inherit;
}

:host([size=sm]) .ids-image,
.ids-image.sm {
  width: 60px;
  height: 60px;
}

:host([size=md]) .ids-image,
.ids-image.md {
  width: 154px;
  height: 120px;
}

:host([size=lg]) .ids-image,
.ids-image.lg {
  width: 300px;
  height: 350px;
}

:host([size=full]) .ids-image,
.ids-image.full {
  width: 100%;
  height: 100%;
}

:host([size=lg]) .ids-image:not(.placeholder):not(.initials),
:host([size=md]) .ids-image:not(.placeholder):not(.initials),
:host([size=sm]) .ids-image:not(.placeholder):not(.initials) {
  object-fit: contain;
}

:host([round=true][size=sm]) .ids-image,
.ids-image.round.sm {
  width: 60px;
  height: 60px;
}

:host([round=true][size=md]) .ids-image,
.ids-image.round.md {
  width: 120px;
  height: 120px;
}

:host([round=true][size=lg]) .ids-image,
.ids-image.round.lg {
  width: 300px;
  height: 300px;
}

:host([round=true][size=full]) .ids-image,
.ids-image.round.full {
  width: 100%;
  height: 100%;
}

:host(:focus-visible) {
  outline: none;
}

:host(:focus) .ids-image,
:host(:focus-visible) .ids-image {
  border-color: var(--ids-image-color-border-focus);
  box-shadow: var(--ids-image-shadow-focus);
}

:host .placeholder,
.ids-image.placeholder {
  border-radius: var(--ids-image-placeholder-border-radius);
  border-color: var(--ids-image-color-border-default);
}
:host .placeholder ids-icon,
.ids-image.placeholder ids-icon {
  color: var(--ids-image-color-text);
}

:host([round=true]) .ids-image,
.ids-image.round {
  border-radius: 50%;
}

:host([user-status]),
.user-status-wrapper {
  position: relative;
}

:host(.disabled),
:host([disabled]) {
  opacity: var(--ids-list-view-item-opacity-disabled);
}

.ids-image {
  box-sizing: border-box;
  border: 1px solid transparent;
  max-width: 100%;
  height: auto;
}
.ids-image:not(.placeholder):not(.initials) {
  display: inline-block;
  object-fit: var(--ids-image-object-fit, cover);
}
.ids-image.placeholder {
  align-items: center;
  display: inline-flex;
  background-color: var(--ids-image-placeholder-color-background);
  justify-content: center;
  min-width: 50px;
  min-height: 50px;
}
.ids-image.initials {
  align-items: center;
  display: flex;
  justify-content: center;
  min-width: 50px;
  min-height: 50px;
  background-color: var(--ids-image-initials-color-background);
  color: var(--ids-color-white-100);
  text-transform: uppercase;
}
.ids-image .audible {
  /* stylelint-disable-next-line property-no-deprecated */
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.user-status {
  position: absolute;
  width: 18px;
  height: 18px;
  right: -1px;
  bottom: -3px;
}
.user-status.available {
  color: var(--ids-image-status-available-color-background);
}
.user-status.busy, .user-status.do-not-disturb {
  color: var(--ids-image-status-busy-color-background);
}
.user-status.away {
  color: var(--ids-image-status-away-color-background);
}
.user-status.unknown {
  fill: var(--ids-image-status-unknown-color-background);
  color: var(--ids-color-transparent);
}
.user-status.meeting {
  color: var(--ids-image-status-busy-color-background);
}
.user-status::before {
  position: absolute;
  border-radius: var(--ids-image-border-radius);
  background-color: var(--ids-color-white-100);
  content: "";
  width: 12px;
  height: 12px;
  left: 3px;
  top: 3px;
  z-index: 1;
}
.user-status::after {
  position: absolute;
  border-radius: var(--ids-image-border-radius);
  background-color: var(--ids-color-background-default);
  content: "";
  width: 16px;
  height: 16px;
  left: 1px;
  top: 1px;
}
.user-status ids-icon {
  z-index: 1;
}

.user-status-wrapper .user-status svg {
  border-radius: var(--ids-image-border-radius);
  background-color: var(--ids-color-background-default);
}
.user-status-wrapper .user-status {
  position: unset;
  width: 18px;
  height: 18px;
  margin-left: 36px;
  margin-top: -18px;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-image/ids-image.scss","webpack://./src/themes/mixins/ids-core-mixins.scss"],"names":[],"mappings":"AAkBA;EACE,qBAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,eAAA;AAjBF;;AAsBE;;EAEE,WAAA;EACA,YAAA;AAnBJ;;AAgBE;;EAEE,YAAA;EACA,aAAA;AAbJ;;AAUE;;EAEE,YAAA;EACA,aAAA;AAPJ;;AAIE;;EAEE,WAAA;EACA,YAAA;AADJ;;AAMA;;;EAGE,mBAAA;AAHF;;AAOE;;EAEE,WAAA;EACA,YAAA;AAJJ;;AACE;;EAEE,YAAA;EACA,aAAA;AAEJ;;AALE;;EAEE,YAAA;EACA,aAAA;AAQJ;;AAXE;;EAEE,WAAA;EACA,YAAA;AAcJ;;AATA;EACE,aAAA;AAYF;;AAPE;;EACE,iDAAA;EACA,yCAAA;AAWJ;;AANA;;EAEE,yDAAA;EACA,mDAAA;AASF;AAPE;;EACE,kCAAA;AAUJ;;AALA;;EAEE,kBAAA;AAQF;;AAJA;;EAEE,kBAAA;AAOF;;AAJA;;EAEE,mDAAA;AAOF;;AAJA;EACE,sBAAA;EACA,6BAAA;EACA,eAAA;EACA,YAAA;AAOF;AAJE;EACE,qBAAA;EACA,8CAAA;AAMJ;AAHE;EACE,mBAAA;EACA,oBAAA;EACA,+DAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAKJ;AAFE;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,4DAAA;EACA,iCAAA;EACA,yBAAA;AAIJ;AADE;ECtGA,uDAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AD0GF;;AAPA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAUF;AAPE;EACE,yDAAA;AASJ;AANE;EAEE,oDAAA;AAOJ;AAJE;EACE,oDAAA;AAMJ;AAHE;EACE,sDAAA;EACA,mCAAA;AAKJ;AAFE;EACE,oDAAA;AAIJ;AAAE;EACE,kBAAA;EACA,6CAAA;EACA,4CAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;AAEJ;AACE;EACE,kBAAA;EACA,6CAAA;EACA,qDAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;AACJ;AAEE;EACE,UAAA;AAAJ;;AAKE;EACE,6CAAA;EACA,qDAAA;AAFJ;AADA;EAME,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AAFF","sourcesContent":["@use '../../themes/mixins/ids-core-mixins' as mixins;\n@use 'sass:list';\n\n$image-sizes: (\n  'sm': (60px, 60px),\n  'md': (154px, 120px),\n  'lg': (300px, 350px),\n  'full': (100%, 100%),\n);\n\n// round images use square dimensions\n$round-image-sizes: (\n  'sm': (60px, 60px),\n  'md': (120px, 120px),\n  'lg': (300px, 300px),\n  'full': (100%, 100%),\n);\n\n:host {\n  display: inline-block;\n  max-width: 100%;\n}\n\n:host([size='full']) {\n  width: 100%;\n  height: inherit;\n}\n\n// set size\n@each $key, $value in $image-sizes {\n  :host([size='#{$key}']) .ids-image,\n  .ids-image.#{$key} {\n    width: list.nth($value, 1);\n    height: list.nth($value, 2);\n  }\n}\n\n// Fix object-fit for lg, md and sm sizes\n:host([size='lg']) .ids-image:not(.placeholder):not(.initials),\n:host([size='md']) .ids-image:not(.placeholder):not(.initials),\n:host([size='sm']) .ids-image:not(.placeholder):not(.initials) {\n  object-fit: contain;\n}\n\n@each $key, $value in $round-image-sizes {\n  :host([round='true'][size='#{$key}']) .ids-image,\n  .ids-image.round.#{$key} {\n    width: list.nth($value, 1);\n    height: list.nth($value, 2);\n  }\n}\n\n// focus state\n:host(:focus-visible) {\n  outline: none;\n}\n\n:host(:focus),\n:host(:focus-visible) {\n  .ids-image {\n    border-color: var(--ids-image-color-border-focus);\n    box-shadow: var(--ids-image-shadow-focus);\n  }\n}\n\n// normal\n:host .placeholder,\n.ids-image.placeholder {\n  border-radius: var(--ids-image-placeholder-border-radius);\n  border-color: var(--ids-image-color-border-default);\n\n  ids-icon {\n    color: var(--ids-image-color-text);\n  }\n}\n\n// round attribute\n:host([round='true']) .ids-image,\n.ids-image.round {\n  border-radius: 50%;\n}\n\n// user-status attribute\n:host([user-status]),\n.user-status-wrapper {\n  position: relative;\n}\n\n:host(.disabled),\n:host([disabled]) {\n  opacity: var(--ids-list-view-item-opacity-disabled);\n}\n\n.ids-image {\n  box-sizing: border-box;\n  border: 1px solid transparent;\n  max-width: 100%;\n  height: auto;\n\n  // img only related\n  &:not(.placeholder):not(.initials) {\n    display: inline-block;\n    object-fit: var(--ids-image-object-fit, cover);\n  }\n\n  &.placeholder {\n    align-items: center;\n    display: inline-flex;\n    background-color: var(--ids-image-placeholder-color-background);\n    justify-content: center;\n    min-width: 50px;\n    min-height: 50px;\n  }\n\n  &.initials {\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    min-width: 50px;\n    min-height: 50px;\n    background-color: var(--ids-image-initials-color-background);\n    color: var(--ids-color-white-100);\n    text-transform: uppercase;\n  }\n\n  .audible {\n    @include mixins.audible();\n  }\n}\n\n.user-status {\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  right: -1px;\n  bottom: -3px;\n\n  // icon colors\n  &.available {\n    color: var(--ids-image-status-available-color-background);\n  }\n\n  &.busy,\n  &.do-not-disturb {\n    color: var(--ids-image-status-busy-color-background);\n  }\n\n  &.away {\n    color: var(--ids-image-status-away-color-background);\n  }\n\n  &.unknown {\n    fill: var(--ids-image-status-unknown-color-background);\n    color: var(--ids-color-transparent);\n  }\n\n  &.meeting {\n    color: var(--ids-image-status-busy-color-background);\n  }\n\n  // Draw a border and ring around the background color\n  &::before {\n    position: absolute;\n    border-radius: var(--ids-image-border-radius);\n    background-color: var(--ids-color-white-100);\n    content: '';\n    width: 12px;\n    height: 12px;\n    left: 3px;\n    top: 3px;\n    z-index: 1;\n  }\n\n  &::after {\n    position: absolute;\n    border-radius: var(--ids-image-border-radius);\n    background-color: var(--ids-color-background-default);\n    content: '';\n    width: 16px;\n    height: 16px;\n    left: 1px;\n    top: 1px;\n  }\n\n  ids-icon {\n    z-index: 1;\n  }\n}\n\n.user-status-wrapper .user-status {\n  svg {\n    border-radius: var(--ids-image-border-radius);\n    background-color: var(--ids-color-background-default);\n  }\n\n  position: unset;\n  width: 18px;\n  height: 18px;\n  margin-left: 36px;\n  margin-top: -18px;\n}\n","// Breakpoints - this cant be tokens\n$breakpoint-xxl: 2463px;\n$breakpoint-xl: 1183px;\n$breakpoint-lg: 928px;\n$breakpoint-md: 927px;\n$breakpoint-sm: 767px;\n$breakpoint-xs: 320px;\n\n// Sets Text Antialiasing\n@mixin antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// vendor prefixed transitions for regular attributes (non-vendor prefixed)\n@mixin transition($transitions-list...) {\n  @each $prefix in $prefixes {\n    #{$prefix}transition: $transitions-list;\n  }\n}\n\n// make the text invisible visually but readable by screen readers\n@mixin audible() {\n  /* stylelint-disable-next-line property-no-deprecated */\n  clip: rect(0, 0, 0, 0);\n  height: 0;\n  line-height: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
